<template>
    <div>
        <transition>

            <!-- Editable -->
            <div v-if="state === 'editable'" class="uk-card uk-card-default uk-card-small">

                <header class="uk-card-header">

                    <div class="uk-grid-small" uk-grid>

                        <h2 class="uk-width-expand uk-flex uk-flex-middle">
                            <span class="uk-badge uk-badge-large uk-margin-small-right">3</span>
                            <span>Дополнительная информация</span>
                        </h2>

                    </div>

                </header>

                <div class="uk-card-body">

                    <div class="uk-grid-small uk-child-width-auto uk-flex uk-flex-center" uk-grid>
                        <div class="uk-width-1-1">
                            <label class="uk-form-label">Комментарий к заказу</label>
                            <textarea v-model="ShopOrder.customer_note" class="uk-textarea" rows="3"></textarea>
                        </div>

                    </div>

                    <div class="uk-text-center uk-margin-medium">
                        <button @click.prevent="$emit('cart::nextStep')" class="uk-button uk-button-secondary">
                            <span>Далее</span>
                            <span class="uk-margin-small-left uk-icon" uk-icon="icon: arrow-right"></span>
                        </button>
                    </div>

                </div>

            </div>

            <!-- Ready -->
            <div v-if="state === 'completed'" class="uk-card uk-card-default uk-card-small">

                <header class="uk-card-header">

                    <div class="uk-grid-small" uk-grid>

                        <h2 class="uk-width-expand uk-flex uk-flex-middle">
                                        <span class="uk-badge uk-badge-large uk-margin-small-right cart-badge-success">
                                            <span class="uk-icon" uk-icon="icon: check"></span>
                                        </span>
                            <span class="uk-text-muted">Дополнительная информация</span>
                        </h2>

                        <div class="uk-width-auto uk-flex uk-flex-middle">
                            <a @click.prevent="$emit('cart::editStep')" class="uk-link-muted">
                                <span class="uk-icon" uk-icon="icon: pencil"></span>
                                <span>Редактировать</span>
                            </a>
                        </div>

                    </div>

                </header>

                <div class="uk-card-body">

                    <div class="uk-grid-small uk-text-small uk-text-muted" uk-grid>

                        <div class="uk-width-1-3">

                            <div class="uk-width-1-1">
                                <dl class="uk-description-list">

                                    <dt>Примечение</dt>
                                    <dd>
                                        {{ ShopOrder.customer_note }}
                                    </dd>

                                </dl>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            state: {
                'type': String,
                'required': true,
                'default': 'next'
            },
            data: {
                'type': Object,
                'required': true,
                'default': {}
            },
        },
        data() {
            return {
                ShopOrder: this.data.ShopOrder,
                deliveryType: {
                    pickup: true
                }
            }
        },
        mounted() {
            this.$emit('update:data', {ShopOrder: this.ShopOrder});
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// CartNote.vue?2b4c79e0